// extracted by mini-css-extract-plugin
module.exports = {"verifyButton":"user_verifyButton__2nrqr","rejected":"user_rejected__3y32a"};